import size from 'lodash/size';
import { TEAM_MODEL, TEAM_TABLE_MODEL } from './teams.model';
import {
  TeamNameCol,
  TeamContributorsCol,
  TeamCreatedAtCol,
  TeamOptionsCol
} from './TeamRow';
import { isGroup } from 'common/utils/utils';

export const getTeamsTableCols = () => {
  return [
    {
      dataPoint: TEAM_TABLE_MODEL.NAME_COMP,
      name: 'NAME',
      isSortedCol: true,
      sortPoint: TEAM_MODEL.NAME,
      style: {
        minWidth: '5rem'
      },
      tableCellHeadProps: {
        style: {
          paddingLeft: '3.2rem'
        }
      }
    },
    {
      dataPoint: TEAM_TABLE_MODEL.CONTRIBUTORS_COUNT_COMP,
      name: 'CONTRIBUTORS',
      isSortedCol: true,
      sortPoint: 'total_contributors',
      style: {
        minWidth: '5rem'
      }
    },
    {
      dataPoint: TEAM_TABLE_MODEL.CREATED_AT_COMP,
      name: 'CREATED',
      isSortedCol: true,
      sortPoint: TEAM_MODEL.CREATED_AT,
      style: {
        minWidth: '10rem'
      }
    },
    {
      dataPoint: TEAM_TABLE_MODEL.OPTIONS_COMP,
      name: '',
      showOnlyOnHover: true,
      style: {
        minWidth: '10rem'
      }
    }
  ];
};

export const getTeamsTableRows = ({
  teams = [],
  onConfigureTeam,
  onConfigureGroup,
  onDeleteTeam,
  onDeleteGroup,
  contributors,
  teamsWithExtraDataIds = {},
  isCurrentUserAdminOrSuperUser,
  accounts
}) => {
  return teams.map(team => {
    const teamChildren = team?.children ?? [];
    const teamId = team?.id;
    const teamWithExtraData = teamsWithExtraDataIds[teamId] || {};

    return {
      ...team,
      total_contributors: size(team[TEAM_MODEL.CONTRIBUTORS]),
      [TEAM_TABLE_MODEL.NAME_COMP]: <TeamNameCol team={team} />,
      [TEAM_TABLE_MODEL.CONTRIBUTORS_COUNT_COMP]: (
        <TeamContributorsCol
          team={team}
          isGroup={isGroup(teamWithExtraData)}
          teamTotalContributors={team.totalContributors ?? []}
        />
      ),
      [TEAM_TABLE_MODEL.CREATED_AT_COMP]: <TeamCreatedAtCol team={team} />,
      [TEAM_TABLE_MODEL.OPTIONS_COMP]: (
        <TeamOptionsCol
          team={team}
          isGroup={isGroup(teamWithExtraData)}
          onConfigureTeam={onConfigureTeam}
          onConfigureGroup={onConfigureGroup}
          onDeleteTeam={onDeleteTeam}
          onDeleteGroup={onDeleteGroup}
          isCurrentUserAdminOrSuperUser={isCurrentUserAdminOrSuperUser}
          accounts={accounts}
        />
      ),
      children: getTeamsTableRows({
        teams: teamChildren,
        onConfigureTeam,
        onConfigureGroup,
        onDeleteTeam,
        onDeleteGroup,
        contributors,
        teamsWithExtraDataIds,
        isCurrentUserAdminOrSuperUser,
        accounts
      })
    };
  });
};
